<template>
     <v-container fluid>
         <v-card>
            <v-toolbar>
                <v-icon>cloud_download</v-icon>
                <v-toolbar-title class="font-weight-light">&nbsp;Generar Reporte Cancelados que no renovaron</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                    <v-icon v-if="action.esFrecuente">favorite</v-icon>
                    <v-icon v-else>favorite_border</v-icon>
                    </v-btn>
                </template>
                <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
                <span v-else>Agregar a Tareas Frecuentes</span>  
                </v-tooltip>
            </v-toolbar>
            <v-card-text>
                <span class="title" >Filtros</span>
                <v-divider></v-divider>
                <v-row dense>
                    <v-col cols="6" lg="3">
                        <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas" autocomplete="disabled"
                            item-text="nombre" item-value="id" label="Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col> 
                    <v-col cols="6" lg="3">
                        <v-autocomplete v-model="filtro.canalesVentaId" :items="listCanalesVenta" autocomplete="disabled" multiple
                            item-text="nombre" item-value="id" label="del Canal de Venta" placeholder="Dejar en blanco para Todos" :menu-props="{minWidth:'400'}">
                            </v-autocomplete>
                    </v-col>
                    <v-col cols="6" lg="3">
                        <v-autocomplete v-model="filtro.productoId" :items="listProductos" autocomplete="disabled" multiple
                            item-text="descripcion" item-value="id" label="Productos" placeholder="Dejar en blanco para Todos" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col>
                    <!-- <div v-if="filtro.productoId">{{ filtro.productoId.map(cv => cv).join()}}</div> -->
                    <v-col cols="6" lg="3">
                        <v-select
                                label='Origen:'
                                v-model="filtro.tipoCanalVentaId"
                                :items="tiposCanalVenta"
                                item-text="descripcion"
                                item-value="id"
                            ></v-select>
                    </v-col>
                </v-row>
                <v-row dense>
                    
                    <v-col cols="6" lg="4">
                       <v-text-field v-model="filtro.fechaCancelaDesde" label="Cancelado Desde" type="date" prepend-icon="event"></v-text-field>
                    </v-col>
                    <v-col cols="6" lg="4">
                       <v-text-field v-model="filtro.fechaCancelaHasta" label="Cancelado Hasta" type="date" prepend-icon="event"></v-text-field>
                    </v-col>
                    <v-col cols="6" lg="4">
                    <v-text-field v-model="filtro.maxDiasAtraso" label="Máximo días atraso" placeholder="Ej. 30"></v-text-field>
                    </v-col>
                </v-row>

            </v-card-text>
             <v-card-actions>
               <v-btn dark  color="green" @click="procesarBase">
                    Descargar Archivo&nbsp;
                    <v-icon >cloud_download</v-icon>                  
                </v-btn>
                <v-spacer></v-spacer>
                <v-col cols="2" lg="2">
                        <v-text-field v-model="filtro.separador" label="Separador en archivo"></v-text-field>
                </v-col>  
                <v-spacer></v-spacer>
                <v-btn dark  color="green" @click="procesarReporte">
                    Generar Reporte&nbsp;
                </v-btn>
            </v-card-actions>

         </v-card>

        <app-loading :loading="loading"></app-loading>

     </v-container>
</template>
<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data() {
        return {
            loading: false,
            filtro: {
                    empresaId: 1,
                    canalventaId: 0,
                    productoId: 0, 
                    tipoCanalVentaId:0,
                    fechaCancelaDesde: null,
                    fechaCancelaHasta: null,
                    maxDiasAtraso: 0,
                    separador: ';'},
            listEmpresas: [],
            listCanalesVenta: [],
            listProductos: [],
            tiposCanalVenta: []
        }
    },
    async created() {
      this.loadEmpresas();
      //this.loadSucursales();
      this.loadCanalesVenta();
      this.loadProductos();
      this.loadTiposCanalVenta();

      this.filtro.fechaCancelaDesde = this.$moment().startOf('month').format('YYYY-MM-DD');
      this.filtro.fechaCancelaHasta = this.$moment().startOf('month').format('YYYY-MM-DD');
    }, 
    computed: {
        ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
        action: function(){
        return this.getActionFromLink(this.$route.path) 
        },
    },
  methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError","setReporteActivo"]),
    ...mapActions(['setStatusTareaFrecuente']),    
    async loadEmpresas(){
        this.loading = true;
        try{
            var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);
            this.listEmpresas = result.list;
            this.listEmpresas.unshift({id:0,nombre:'(Todas)'})
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadCanalesVenta(){
      this.loading = true;
      try{
        var result = await http.get('canalesventa/habilitadosparausuario?usuarioId='+ this.user.id);

        this.listCanalesVenta = result.list;
         //this.listCanalesVenta.unshift({id:0,nombre:'(Todos)'});
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadProductos(){
      this.loading = true;
      try{
        var result = await http.get('productos/');        

        this.listProductos = result.list;
        // this.listProductos.unshift({id:0,descripcion:'(Todos)'});
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadTiposCanalVenta() {
        this.loading = true
        try {
            var result = await http.get('tiposcanalventa');
            this.tiposCanalVenta = result.list;
            //this.tiposCanalVenta.unshift({id:0,descripcion:'(Todos)'});
        } catch (error) {
            // Error
            Vue.$log.error(error);
        }
        this.loading = false
    },
    validar(){
       
        if(!this.filtro.fechaCancelaDesde) 
        {
            this.alertWarning('Debe ingresar la Fecha de cancelacion desde.');
            return false;
        }

        if(!this.filtro.fechaCancelaHasta) 
        {
            this.alertWarning('Debe ingresar la Fecha de cancelacion hasta.');
            return false;
        }

        return true;
    },
    async procesarReporte(){
        // validaciones
        if(!this.validar()) 
        {
            return;
        }
        
        var self = this;

        let canalVentaNombre = '';
        let productoNombre = '';

        //Si se eligió TODOS
        if(!this.filtro.canalesVentaId || this.filtro.canalesVentaId.length == 0)
        {
            canalVentaNombre = 'Todos';
            //Si no tiene acceso a todos los canaes armo un string con todos los canales de venta habilitados para el usuario.
            if(!this.$store.state.user.accesoTodosCanalesVenta)
            {
                this.filtro.canalesVenta = this.listCanalesVenta.map(cv => cv.id).join();
            }
            // si no lo pongo en 0
            else
            {
                this.filtro.canalesVenta = '0';
            }
        }
        //si se eligió un filtro mando ese
        else
        {
            canalVentaNombre = (this.filtro.canalesVentaId.length > 1 ? 'Varios' : this.listCanalesVenta.find(cv => cv.id == this.filtro.canalesVentaId[0]).nombre); 
            this.filtro.canalesVenta = this.filtro.canalesVentaId.toString();
        }
        //Si se eligió TODOS
        if(!this.filtro.productoId || this.filtro.productoId.length == 0)
        {            
            this.filtro.productos = '0';
        }
        //si se eligió un filtro mando ese
        else
        {            
            productoNombre = (this.filtro.productoId.length > 1 ? 'Varios' : this.listProductos.find(cv => cv.id == this.filtro.productoId[0]).nombre); 
            this.filtro.productos = this.filtro.productoId.toString();
        }

        try {
            self.loading = true;

            console.log(this.filtro.productoId);
               
            let params = [];
            params.push({
                "Version": this.$store.state.version,
                "EmpresaId": this.filtro.empresaId,
                "FechaCancelaDesde": this.filtro.fechaCancelaDesde,
                "FechaCancelaHasta": this.filtro.fechaCancelaHasta,
                "Productos": this.filtro.productos,
                "CanalesVenta": this.filtro.canalesVenta.toString(),
                "MaxDiasAtraso": this.filtro.maxDiasAtraso,
                "TipoCanalVentaId": this.filtro.tipoCanalVentaId
            } );

            this.setReporteActivo({reporte: 'Cancelados que no renovaron.trdp', params: params})
            window.open('/report-viewer');
            
        } catch (error) {
            // Error
            self.alertError(error)
        }
        self.loading = false
    },
    
async procesarBase(){

         // validaciones
        if(!this.validar()) 
        {
            return;
        }
        
        var self = this;

        //Si se eligió TODOS
        if(!this.filtro.canalesVentaId || this.filtro.canalesVentaId.length == 0)
        {
            //Si no tiene acceso a todos los canaes armo un string con todos los canales de venta habilitados para el usuario.
            if(!this.$store.state.user.accesoTodosCanalesVenta)
            {
                this.filtro.canalesVenta = this.listCanalesVenta.map(cv => cv.id).join();
            }
            // si no lo pongo en 0
            else
            {
                this.filtro.canalesVenta = '0';
            }
        }
        //si se eligió un filtro mando ese
        else
        {
            this.filtro.canalesVenta = this.filtro.canalesVentaId.toString();
        }
        //Si se eligió TODOS
        if(!this.filtro.productoId || this.filtro.productoId.length == 0)
        {            
            this.filtro.productos = '0';
        }
        //si se eligió un filtro mando ese
        else
        {            
            this.filtro.productos = this.filtro.productoId.toString();
        }
console.log(this.filtro)

        let params = {
                "empresaId": this.filtro.empresaId,
                "fechaCancelaDesde": this.filtro.fechaCancelaDesde,
                "fechaCancelaHasta": this.filtro.fechaCancelaHasta,
                "productos": this.filtro.productos,
                "canalVentaNombre": this.filtro.canalesVenta.toString(),
                "maxDiasAtraso": this.filtro.maxDiasAtraso,
                "tipoCanalVentaId": this.filtro.tipoCanalVentaId,
                "separador": this.separador
            } ;

        try {
            self.loading = true;

            await http.post('filegeneration/archivocanceladosquenorenovaron', JSON.stringify( {parametros: params} ) )
                .then(resp => {
                    console.log(resp);

                    if(resp.error ){
                        self.alertError(resp.error);
                    }
                    else{
                        self.alertSuccess('Se generó correctamente el archivo. Aguarde unos instantese mientras se descarga el archivo...');
                        
                        self.loading = true;
                        self.downloadFile(resp, 'Reporte Cancelados Que No Renovaron.csv');
                        self.loading = false;
                    }

                })
                .catch((e) => {
                    self.alertError(e)
                });
            
        } catch (error) {
            // Error
            self.alertError(error)
        }
        self.loading = false
    },

  async downloadFile(file, renameTo){
        //convierto el string del path a base64 para poder mandarlo
        let base64String = '';
        base64String = btoa(file.fullPath);
        
        http.get('filemanagement/getfilebypath/'+base64String)
        .then(resp => {
            let dataType = '';
            switch(resp.extension)
            {
                case '.doc':
                case '.docx':
                case '.DOC':
                case '.DOCX':
                    dataType = 'data:application/vnd.ms-word';
                    break;
                case '.pdf':
                case '.PDF':
                    dataType = 'data:application/pdf'
            }
            
            //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
            var arrayBuffer = this.base64ToArrayBuffer(resp.file);
            this.saveByteArray(renameTo, arrayBuffer,dataType);
        })
        .catch((e) => this.alertError(e));
    },

      base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
      }
      return bytes;
    },
    
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], {type: dataType});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();      
    },
},

}
</script>